import { apiGet } from '../api.ts'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { createUrl } from '@/util/url.ts'
import { MINUTE } from '@/constant/time.ts'

export interface IReqGetUsersBbox {
    startLat: number
    endLat: number
    startLng: number
    endLng: number
}

export const apiGetUsersBbox = async (params: IReqGetUsersBbox) => {
    return await apiGet<IUserBbox[]>(createUrl(`/protectee/bbox`, params))
}

const useQueryGetUsersBbox = (params?: IReqGetUsersBbox) => {
    return useQuery({
        queryKey: [...QueryCacheKeys.user.getUsersBbox(), params],
        refetchInterval: 1 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetUsersBbox(params!)
            return data
        },
        enabled: !!params,
        placeholderData: keepPreviousData
    })
}

export default useQueryGetUsersBbox

export interface IUserBbox {
    id: number
    name: string
    location?: IPosition
    todayAlert: AlertStatus
    deviceStatus: DeviceStatus
}

export interface IPosition {
    latitude: number
    longitude: number
    timestamp: string
    accuracy: number
}

export enum AlertStatus {
    NONE = 'none',
    EMERGENCY = 'emergency',
    BIO = 'bio'
}

export enum DeviceStatus {
    ONLINE = 'online',
    OFFLINE = 'offline',
    CHARGING = 'charging',
    EMERGENCY = 'emergency'
}
